import { r as registerInstance, h } from './index-5faac9d7.js';
import { a5 as SUBCATEGORY } from './currency-7be6806c.js';

const PesAppSprykerSubcategoryListing = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.host = undefined;
    this.showBreadcrumbs = undefined;
    this.subcategoryData = null;
    this.subcategoryId = undefined;
    this.showDocuments = true;
    this.enableCommerceConnector = true;
    this.showBuyOnline = true;
    this.productCtas = undefined;
    this.showCompare = true;
    this.recentlyViewedProducts = undefined;
    this.isPBS = false;
    this.searchParams = {};
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.storageName = '';
    this.currentPageStorageKey = '';
  }
  componentWillLoad() {
    this.storageName = `${this.host}${this.countryCode}/${this.languageCode}/`;
    this.currentPageStorageKey = `${SUBCATEGORY}/${this.subcategoryId}`;
  }
  render() {
    var _a, _b, _c;
    const { hmcBanner } = this.subcategoryData.subcategoryListingRanges;
    const { analyticsPageData } = this.subcategoryData.metaTags;
    return (h("pes-app-category-subcategory-listing", { host: this.host, showBreadcrumbs: this.showBreadcrumbs, categoryOrSubcategoryId: this.subcategoryId, showDocuments: this.showDocuments, enableCommerceConnector: this.enableCommerceConnector, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, breadcrumbs: (_a = this.subcategoryData) === null || _a === void 0 ? void 0 : _a.subcategoryBreadcrumbs, descriptionInfo: (_b = this.subcategoryData) === null || _b === void 0 ? void 0 : _b.subcategoryDescription, listingInfo: (_c = this.subcategoryData) === null || _c === void 0 ? void 0 : _c.subcategoryListingRanges, hmcBannerInfo: hmcBanner, searchParams: this.searchParams, recentlyViewedProducts: this.recentlyViewedProducts, isPBS: this.isPBS, isSubcategoryPage: true, productCtas: this.productCtas, storageName: this.storageName, currentPageStorageKey: this.currentPageStorageKey, analyticsPageData: analyticsPageData }));
  }
};

export { PesAppSprykerSubcategoryListing as pes_app_spryker_subcategory_listing };
